<template>
  <div class="member-guide-box" v-if="show && apiFinish">
    <!-- v--modal-overlay -->
    <div class="user-buy">
      <div
        v-show="!iframeShown"
        class="loading"
      ></div>
      <iframe
        v-show="iframeShown"
        ref="iframeRef"
        name="user-buy"
        class="iframe"
        :src="embeddedLink"
      ></iframe>
    </div>
</div>
</template>

<script>
import data from "./data.vue";
import {PeriodTypes, MemberTypes, PageCodes} from './codes';
import { mapGetters } from "vuex";

function qsStringify (obj) {
  const queryString = Object.entries(obj).reduce((qs, [k, v], i) => {
    const separator = i === 0 ? '' : '&';
    qs += v !== void 0 ? `${separator}${k}=${v}` : '';
    return qs;
  }, '');
  return queryString;
}

export default {
  name: "MemberGuide",
  mixins: [data],
  props: {
    context: {
      type: Object,
      default () {
        return {
          $store: {}
        }
      }
    },
    isSubtitle: {
      type: Boolean,
      default: false,
    },
    funcRight: {
      type: Object,
      default() {
        return {
          name: "",
          type: "",
        };
      },
    },
    link: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      embeddedLink: '',
      iframeShown: '',
      msgOfCounts: {
        close: () => void 0
      }
    }
  },
  computed: {
    ...mapGetters([
      'UserMsg',
      'UserLevelInfo'
    ])
  },
  watch: {
    // cards: {
    //   handler () {
    //     this.setEmbeddedLink();
    //   }
    // },
    // embeddedLink: {
    //   handler () {
    //     console.log(`Turbo ~ setTimeout ~ this.iframeShown:`, this.iframeShown)
    //     setTimeout(() => {
    //       this.iframeShown = true;
    //     }, 8000);
    //   }
    // },
    show: {
      handler () {
        if (this.show) {
          this.setEmbeddedLink();
          this.receiveLink();
        }
        setTimeout(() => {
          this.iframeShown = true;
        }, 8000);
      }
    }
  },
  created () {
    this.bindEvents();
  },
  beforeDestroy () {
    this.unbindEvents();
    this.msgOfCounts.close();
  },
  methods: {
    getPageCode () {
      return PageCodes[this.funcRight.type] || 19;
    },
    async setEmbeddedLink () {
      const linkOrigin = location.origin;
      const linkPath = '/pvip/iframe-index';
      const searchParams = {};

      if (this.link === 'buyPersonVip' || this.link === 'buyEnterpriseVip') {
        return;
      }

      if (this.link) {
        return;
      }

      let target = '';
      ['vip', 'shopVip', 'enterpriseVip', 'upEnterpriseVip'].some(key => {
        if (this.cards[key]) {
          target = key;
          return true;
        }
      });
      const userMsg = this.context.$store.getters.UserMsg || {};
      if (target !== 'upEnterpriseVip') {
        target = 'baseEnterpriseVip';
        const level = userMsg.level || 0;
        const levelType = userMsg.levelType || 0;
        if (levelType === 2) {
          target = 'upEnterpriseVip';
        }
        else if (level === 142 || levelType <= 1) {
          target = 'enterpriseVip';
        }
        if (!levelType && !level) {
          target = 'baseEnterpriseVip';
        }
      }

      const packRights = ['applyWatermark', 'AIDubbing', '720P'];
      const isPackRights = packRights.includes(this.funcRight.type);
      switch (target) {
        case 'vip':
          // 废弃 searchParams.iframeSource = PeriodCodes.Month;
          searchParams.iframeSource = PeriodTypes.Year;
          break;
        case 'shopVip':
          if (isPackRights && [1, 3].some(v => v == userMsg.month)) { // eslint-disable-line
            // 废弃 searchParams.iframeSource = PeriodCodes.Pack;
            searchParams.iframeSource = PeriodTypes.Year;
          } else {
            // 废弃 searchParams.iframeSource = PeriodCodes.Year;
            searchParams.iframeSource = PeriodTypes.Year;
            searchParams.memberType = MemberTypes.Shop;
            searchParams.isPricing = void 0;
          }
          break;
        case 'baseEnterpriseVip':
          // 废弃 searchParams.iframeSource = PeriodCodes.Year;
          searchParams.iframeSource = PeriodTypes.Year;
          searchParams.memberType = MemberTypes.BaseEnterprise;
          searchParams.isPricing = true;
          break;
        case 'enterpriseVip': {
          // if (isPackRights && [1, 3].some(v => v == userMsg.month)) { // eslint-disable-line
          //   searchParams.iframeSource = PeriodCodes.Pack;
          // } else {
          //   searchParams.iframeSource = PeriodCodes.Year;
          //   searchParams.memberType = MemberTypes.Enterprise;
          //   searchParams.isPricing = true;
          // }
          // 废弃 searchParams.iframeSource = PeriodCodes.Year;
          searchParams.iframeSource = PeriodTypes.Year;
          searchParams.memberType = MemberTypes.Enterprise;
          searchParams.isPricing = true;
        }
          break;
        case 'upEnterpriseVip':
          // 废弃 searchParams.iframeSource = PeriodCodes.Year;
          searchParams.iframeSource = PeriodTypes.Year;
          searchParams.memberType = MemberTypes.UpEnterprise;
          searchParams.isPricing = true;
          if (userMsg.isChartletCompanyLevel) {
            searchParams.memberType = MemberTypes.UpEnterprise;
            searchParams.isAIPricingDialog = 'true';
          }
          break;
        default:
        // 废弃 searchParams.iframeSource = PeriodCodes.Year;
        searchParams.iframeSource = PeriodTypes.Year;
      }

      if (target === 'right' && state.rightsModule.length) {
        // 废弃 searchParams.iframeSource = PeriodCodes.Pack;
        searchParams.iframeSource = PeriodTypes.Year;
      }

      searchParams.page = this.getPageCode();

      const {data: respData} = await this.$http.get('/api/user/limit', {
        params: {
          type: 'draft-work'
        }
      });
      const draftLimit = respData.data.draft.limit || 0;
      const worksLimit = respData.data.work.limit || 0;
      const { shouldShow, upgradeTo } = this.showCountsMessage({
        draftLimit,
        worksLimit
      });
      if (shouldShow) {
        searchParams.memberType = upgradeTo;
      }

      const qs = qsStringify(searchParams);

      this.embeddedLink = `${linkOrigin}${linkPath}?${qs}`;
    },

    async receiveLink () {
      if (!this.link) {
        return;
      }
      const linkOrigin = location.origin;
      const linkPath = '/pvip/iframe-index';
      const searchParams = {};
      let propsLink = this.link;

      if (propsLink === 'buyPersonVip') {
        propsLink = 'buyBaseEnterpriseVip';
        const userMsg = this.context.$store.getters.UserMsg || {};
        const level = userMsg.level || 0;
        if (level === 142) {
          propsLink = 'buyEnterpriseVip'
        }
      }

      if (propsLink === 'buyBaseEnterpriseVip') {
        // 废弃 searchParams.iframeSource = PeriodCodes.Year;
        searchParams.iframeSource = PeriodTypes.Year;
        searchParams.memberType = MemberTypes.BaseEnterprise;
        searchParams.isPricing = true;
      }
      if (propsLink === 'buyEnterpriseVip') {
        // 废弃 searchParams.iframeSource = PeriodCodes.Year;
        searchParams.iframeSource = PeriodTypes.Year;
        searchParams.memberType = MemberTypes.Enterprise;
        searchParams.isPricing = true;
      }
      if (propsLink === 'buyUpEnterpriseVip') {
        // 废弃 searchParams.iframeSource = PeriodCodes.Year;
        searchParams.iframeSource = PeriodTypes.Year;
        searchParams.memberType = MemberTypes.UpEnterprise;
        searchParams.isPricing = true;
      }
      if (propsLink === 'buyEnterpriseAIVip') {
        // 废弃 searchParams.iframeSource = PeriodCodes.Year;
        searchParams.iframeSource = PeriodTypes.Year;
        searchParams.memberType = MemberTypes.EnterpriseAI;
        searchParams.isPricing = true;
        searchParams.isAIPricingDialog = 'true';
      }
      if (propsLink === 'buyUpEnterpriseAIVip') {
        // 废弃 searchParams.iframeSource = PeriodCodes.Year;
        searchParams.iframeSource = PeriodTypes.Year;
        searchParams.memberType = MemberTypes.UpEnterprise;
        searchParams.isPricing = true;
        searchParams.isAIPricingDialog = 'true';
      }
      searchParams.page = this.getPageCode();

      const {data: respData} = await this.$http.get('/api/user/limit', {
        params: {
          type: 'draft-work'
        }
      });
      const draftLimit = respData.data.draft.limit || 0;
      const worksLimit = respData.data.work.limit || 0;
      const { shouldShow, upgradeTo } = this.showCountsMessage({
        draftLimit,
        worksLimit
      });
      if (shouldShow) {
        searchParams.memberType = upgradeTo;
      }

      const qs = qsStringify(searchParams);
      this.embeddedLink = `${linkOrigin}${linkPath}?${qs}`;
    },

    onPostMessage (e) {
      if (e.data.dialogOpen) {
        console.timeEnd('fromLoadToDialog');
        // this.iframeShown = true;
        return;
      }
      if (e.data.clickClose) {
        this.msgOfCounts.close();
        this.show = false;
        // eventBus.emit('popup.hide', ['PopupUserBuy']);
        return;
      }

      // pay finished
      if (e.data.code === 200 && e.data.body) {
        window.reload();
        // userInfoStore.userLevel.fetchData();
        // eventBus.emit('popup.hide', 'PopupUserBuy');

        // if (e.data && e.data.body && e.data.body.endDay) {
        //   eventBus.emit('popup.show', ['PopupUserBuyFinished', {
        //     message: e.data
        //   }]);
        // } else {
        //   ElMessage({
        //     message: '权益包购买成功！',
        //     duration: 3000,
        //     type: 'success'
        //   });
        // }
      }
    },

    bindEvents () {
      window.addEventListener('message', this.onPostMessage);
    },
    unbindEvents () {
      window.removeEventListener('message', this.onPostMessage);
      this.$refs.iframeRef.removeEventListener('load', this.onIframeLoad);
    },
    showIframe () {
      if (!this.$refs.iframeRef) return;
      const el = this.$refs.iframeRef;
      el.removeEventListener('load', onIframeLoad);
      el.addEventListener('load', onIframeLoad);
    },
    onIframeLoad () {
      console.time('fromLoadToDialog');
    },

    showCountsMessage ({draftLimit, worksLimit} = {}) {
      const shouldShow = ['draftNumber', 'worksNumber'].includes(this.funcRight.type);
      if (!shouldShow) {
        return {
          shouldShow
        };
      }

      const model = {
        level: '',
        upgrade: '',
        limit: 50,
        countName: '草稿'
      };

      if (this.funcRight.type === 'worksNumber') {
        model.limit = worksLimit || 50;
        model.countName = '作品';
      } else {
        model.limit = draftLimit || 50;
        model.countName = '草稿';
      }
      if (!this.context || !this.context.$store) {
        return;
      }
      const userMsg = this.context.$store.getters.UserMsg || {};
      const userLevelInfo = this.context.$store.getters.UserLevelInfo || {};
      const level = userMsg.level || 0;
      const levelType = userMsg.levelType || 0;
      const levelNewType = userMsg.levelNewType || 0;
      const levelCode = userLevelInfo.levelCode || 0;
      let upgradeTo = MemberTypes.Enterprise;
      const proLevelIsAnimation = levelNewType >= 17;

      if (levelType === 2) {
        model.level = proLevelIsAnimation ? '动画Pro版' : '高级版';
        model.upgrade = '动画Pro+版';
        upgradeTo = MemberTypes.UpEnterprise;
      }
      if (levelType <= 1) {
        model.level = proLevelIsAnimation ? '动画基础版' : '基础版';
        model.upgrade = '动画Pro版';
        upgradeTo = MemberTypes.Enterprise;
      }
      if (levelType <= 1 && levelNewType >= 22) {
        model.level = proLevelIsAnimation ? '动画标准版' : '基础版';
        model.upgrade = '动画Pro版';
        upgradeTo = MemberTypes.Enterprise;
      }
      if (levelCode === 0) {
        model.level = '免费版';
        model.upgrade = '动画Pro版';
        upgradeTo = MemberTypes.Enterprise;
      }
      if ([147, 148].includes(level)) {
        model.level = '教育版';
        model.upgrade = '动画Pro版';
        upgradeTo = MemberTypes.Enterprise;
      }
      const el = document.querySelector('.msgOfCounts');
      if (!el) {
        this.msgOfCounts = this.$message({
          dangerouslyUseHTMLString: true,
          message: `<div style="margin-top: 2px;">
            您的账户是${wrap(model.level)}，最多只能保留${wrap(model.limit)}${wrap('个')}动画${model.countName}，请升级到 ${wrap(model.upgrade)} 提升可保留的${model.countName}数量。
          <div>`,
          duration: 0,
          type: 'error',
          customClass: 'msgOfCounts'
        });
      }

      function wrap (text) {
        return `<span class="highlight" style="font-weight: bold">${text}</span>`;
      }
      return {
        shouldShow,
        upgradeTo
      };
    }
  }
}
</script>

<style lang="scss" scoped>
.user-buy {
  position: relative;
  width: 100%;
  height: 100%;
  background-color: transparent;
  .iframe {
    width: 100%;
    height: 100%;
    border: none;
    background-color: transparent;
  }
  .loading {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 50px;
    height: 120px;
    background-image: url(../../assets/maskLoading.gif);
    background-size: 100% 100%;
    background-repeat: no-repeat;
  }
}

.member-guide-box {
  position: absolute;
  left: 0;
  top: 0;
  z-index: 9000;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  font-family: "Microsoft YaHei-Regular, Microsoft YaHei";
  font-size: 12px;
  .content {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    z-index: 5;
    width: 636px;
    border-radius: 4px;
    box-sizing: border-box;
    padding: 50px 42px 26px 42px;
    text-align: center;
    // background-color: #fff;
    // background-image: url("../../assets/memberGuide/bg.png");
    // background-repeat: no-repeat;
    // background-size: 636px 348px;
    // background-position: 0 0;
    text-align: left;
  }
}
</style>



// WEBPACK FOOTER //
// src/plugins/memberGuide/index.vue